// Запуск воспроизведения — ОДНО правило на приложение.
//
// `HTMLMediaElement.play()` возвращает промис, и он отклоняется В ШТАТНЫХ
// случаях, а не только при поломке:
//   - `NotAllowedError`  — автоплей без жеста пользователя;
//   - `AbortError`       — воспроизведение прервано `pause()` или сменой `src`;
//   - `NotSupportedError`— «The element has no supported sources»: `src` пуст
//     либо ссылка протухла (presigned-адрес живёт час).
//
// Оставленный без обработки, любой из них становится unhandled rejection —
// а Hawk SDK ловит их наравне с настоящими падениями. Так «The element has no
// supported sources» и прилетело с прода 27.08.2026: три места звали
// `void el.play()` без `.catch`, и обычный отказ браузера превращался в
// сообщение об ошибке.
//
// Поэтому вызывать `play()` напрямую в компонентах не нужно: здесь промис
// всегда разрешается, а результат — честный ответ «пошло / не пошло», по
// которому поверхность сама решает, что показать.

/** Отказ, который значит «браузер не стал играть», а не «приложение сломалось». */
function isExpectedPlaybackRejection(err: unknown): boolean {
	if (!(err instanceof DOMException)) return false;
	return (
		err.name === "NotAllowedError" || err.name === "AbortError" || err.name === "NotSupportedError"
	);
}

/**
 * Запустить воспроизведение. Никогда не отклоняется.
 *
 * @returns `true` — воспроизведение началось; `false` — браузер отказал
 * (нет жеста, нет источника, старт прерван).
 */
export async function startPlayback(
	element: HTMLMediaElement | null | undefined,
): Promise<boolean> {
	if (!element) return false;
	try {
		await element.play();
		return true;
	} catch (err) {
		if (!isExpectedPlaybackRejection(err)) {
			// eslint-disable-next-line no-console -- слышимой альтернативы нет, диагностика нужна
			console.warn("Playback failed", err);
		}
		return false;
	}
}
